import React, { useEffect, useState } from "react";
import SelectInputMap from "../../../InputForms/SelectInputMap/SelectInputMap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import { OptionType } from "../../../InputForms/SelectInputMap/SelectInputMap";
import { closeNavTab } from "../../../../../../shared/components/NavTab/fuctionsControl";
import { setClickedStaitionByPlacemark, setRoadmaps, setTransports, setVehTransports } from "../.././../../../../pages/Map/store/mapScreenSlce";

interface InputSelectBusStopProps {
    options: OptionType[];
    isLoading: boolean;
    handleSelect: (option: OptionType | null) => void;
    isBusStaitionTo?: boolean;
    isDisabled?: boolean;
}

const InputSelectBusStop: React.FC<InputSelectBusStopProps> = ({ options, isLoading, handleSelect, isBusStaitionTo, isDisabled }) => {
    const { mapMode, city, cityTo, busStation, busStationTo, clikedStaitionByPlacemark } = useSelector((state: RootState) => state.mapScreen)
    const dispatch = useDispatch();
    const [selectedValue, setSelectedValue] = useState<OptionType | undefined>(null);

    function onClear() {
        setSelectedValue(null);
        onChange(null);
        dispatch(setClickedStaitionByPlacemark());
        if (mapMode === 'busStops') {
            dispatch(setRoadmaps([])); // сбросить отображение маршрута на карте, если открыт
            dispatch(setVehTransports([]))
        }
        closeNavTab();
    }

    function onChange(option: OptionType | undefined) {
        setSelectedValue(option);
        handleSelect(option);
        closeNavTab();
    }

    function handleClickStaition() {
        const options = { value: clikedStaitionByPlacemark.id, label: clikedStaitionByPlacemark.name };
        setSelectedValue(options);
    }

    useEffect(() => {
        if (!isBusStaitionTo && clikedStaitionByPlacemark && !selectedValue) {
            handleClickStaition();
        } else if (!isBusStaitionTo && !clikedStaitionByPlacemark && !busStation) {
            setSelectedValue(null);
        }
    }, [clikedStaitionByPlacemark, selectedValue, isBusStaitionTo])

    // Очищать/синхронизировать инпут в случае, если в сторе он очищен/изменён
    useEffect(() => {
        const storeStation = isBusStaitionTo ? busStationTo : busStation;

        // 1) В сторе очистили значение => очищаем локальный инпут
        if (!storeStation && selectedValue) {
            setSelectedValue(null);
            return;
        }

        // 2) В сторе выставили значение извне (например, после клика по карте/автоселекта)
        // и оно не совпадает с тем, что в инпуте сейчас
        if (storeStation) {
            const storeId = storeStation.id?.toString();
            const selectedId = selectedValue?.value?.toString();

            if (storeId && storeId !== selectedId) {
                setSelectedValue({ value: storeId, label: storeStation.name });
            }
        }
    }, [isBusStaitionTo, busStation, busStationTo]); // специально без selectedValue, чтобы не зациклить

    const isCheckCity = isBusStaitionTo ? city : cityTo

    return (
        <SelectInputMap
            selectedValue={selectedValue}
            placeholder={"Выберите остановку"}
            options={options}
            isLoading={isLoading}
            onChange={onChange}
            onClear={onClear}
            isDisabled={isDisabled}
        />
    );
};

export default InputSelectBusStop;